import React from 'react';
import Button from '../../../components/ui/Button';

const QuickActionPanel = ({ onAction }) => {
  const quickActions = [
    { id: 'bulk-approve', label: 'Massenfreigabe', icon: 'CheckSquare', variant: 'default' },
    { id: 'generate-report', label: 'Bericht erstellen', icon: 'FileText', variant: 'outline' },
    { id: 'team-meeting', label: 'Team-Meeting', icon: 'Users', variant: 'outline' },
    { id: 'system-check', label: 'Systemprüfung', icon: 'Activity', variant: 'outline' }
  ];

  return (
    <div className="bg-card rounded-lg p-6 border border-border">
      <h3 className="text-lg font-semibold text-foreground mb-4">Schnellaktionen</h3>
      <div className="grid grid-cols-2 gap-3">
        {quickActions?.map((action) => (
          <Button
            key={action?.id}
            variant={action?.variant}
            iconName={action?.icon}
            iconPosition="left"
            fullWidth
            onClick={() => onAction(action?.id)}
          >
            {action?.label}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default QuickActionPanel;